import React,{createContext,useContext,useEffect,useState} from "react";
import {onAuthStateChanged,signOut} from "firebase/auth";
import {doc,getDoc} from "firebase/firestore";
import {auth,db} from "../firebase/firebase.js";

const AuthContext=createContext();
export const useAuth=()=>useContext(AuthContext);

export function AuthProvider({children}){

  const defaultUser={
    uid:null,
    email:null,
    role:null,
    businessId:null,
    resellerId:null
  };

  const[user,setUser]=useState(defaultUser);
  const[loading,setLoading]=useState(true);

  useEffect(()=>{
    const unsub=onAuthStateChanged(auth,async(firebaseUser)=>{
      if(!firebaseUser){
        setUser(defaultUser);
        setLoading(false);
        return;
      }

      // 🔑 FETCH ROLE FROM FIRESTORE (THIS WAS MISSING)
      const snap=await getDoc(doc(db,"users",firebaseUser.uid));

      if(!snap.exists()){
        setUser(defaultUser);
        setLoading(false);
        return;
      }

      setUser({
        uid:firebaseUser.uid,
        email:firebaseUser.email,
        ...snap.data()
      });

      setLoading(false);
    });

    return ()=>unsub();
  },[]);

  const logout=async()=>{
    await signOut(auth);
    setUser(defaultUser);
  };

  return(
    <AuthContext.Provider value={{user,loading,logout}}>
      {children}
    </AuthContext.Provider>
  );
}
